import AsphaltShingleRoofing from "./asphalt-shingle-roofing.svg";
import MetalRoofing from "./metal-roofing.svg";
import TileRoofing from "./tile-roofing.svg";
import WoodShakeRoofing from "./wood-shake-roofing.svg";

const icons = {
  "asphalt-shingle-roofing": AsphaltShingleRoofing,
  "metal-roofing": MetalRoofing,
  "tile-roofing": TileRoofing,
  "wood-shake-roofing": WoodShakeRoofing,
};

export default icons;
